// extracted by mini-css-extract-plugin
export default {"ugPagerWrap":"UgPager_ugPagerWrap__V8q7F","pagerBtnUlm":"UgPager_pagerBtnUlm__msf6X","pagerBtnActive":"UgPager_pagerBtnActive__LSnoP","pagerChevron":"UgPager_pagerChevron__nNuop"};